module.exports = __webpack_public_path__ + "img/q31-6.b986d4dd.jpg";